export default __webpack_public_path__ + "static/media/referrals.a4d47a2e.png";